import { getUpstreamEventDetail } from 'client';
import { LoaderFunctionArgs } from 'react-router';
import { useRouteLoaderData } from 'react-router';
import invariant from 'tiny-invariant';

import { createBreadcrumbConfig } from 'DesignSystem/features/dynamic-breadcrumbs/dynamic-breadcrumbs.utils';
import { PageLayoutMain, PageLayoutRoot, PageLayoutSidebar } from 'DesignSystem/page-layout';

import EventDetails from './components/event-details';
import EventSidebar from './components/sidebar';

export async function loader({ params }: LoaderFunctionArgs) {
  const { eventId } = params;
  invariant(eventId, 'eventId is required');

  const response = await getUpstreamEventDetail({
    path: {
      event_uuid: eventId,
    },
  });
  const event = response.data;

  return {
    event,
    ...createBreadcrumbConfig({
      label: event?.title || 'Event Details',
      module: 'DISRUPTION_MONITOR',
    }),
  };
}

export const useEventDetails = () => {
  return useRouteLoaderData<typeof loader>('drm-event-details');
};

export function Component() {
  return (
    <PageLayoutRoot
      style={
        {
          '--sidebar-width': '340px',
        } as React.CSSProperties
      }
    >
      <PageLayoutMain className="bg-background">
        <EventDetails />
      </PageLayoutMain>
      <PageLayoutSidebar className="relative overflow-hidden">
        <EventSidebar />
      </PageLayoutSidebar>
    </PageLayoutRoot>
  );
}
